import { render, staticRenderFns } from "./AmapScatter.vue?vue&type=template&id=ee9630a2&scoped=true&"
import script from "./AmapScatter.vue?vue&type=script&lang=js&"
export * from "./AmapScatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9630a2",
  null
  
)

export default component.exports